import request from './'

export const getPrices = ({ ids, cartId }) => {
  return request({
    method: 'POST',
    url: '/api/boomerang/prices',
    data: {
      filter: {
        item_id: ids,
        cart_id: cartId
      }
    }
  })
}

export const getPrice = ({ id, cartId, configuration }) => {
  return request({
    method: 'POST',
    url: '/api/boomerang/prices',
    data: {
      filter: {
        item_id: id,
        cart_id: cartId,
        configuration
      }
    }
  })
}
